'use client';
import {Link} from "@/i18n/routing";
import {useTranslations} from 'next-intl';
import {logoutAction} from '@/actions/auth';
import {getGqlErrorToast} from '@/libs/api/errorHandler';
import {useState} from 'react';
import {useErrorAlert} from '@/hooks/useSweetAlert';
import {CALLBACK_URL_PARAM, LOGIN_ROUTE_NAME, LOGOUT_ROUTE_NAME, PRIVATE_ROUTE_NAME} from '@/libs/constants/common.constants';
import {usePathname} from '@/i18n/routing';
import {useUserContext} from '@/providers/UserContext';

export default function HeaderAccountSelector() {
  const t = useTranslations('header');
  const e = useTranslations('error.message');
  const [logoutLoading, setLogoutLoading] = useState(false);
  const toast = useErrorAlert();
  
  const {user, deleteUser} = useUserContext();
  const pathname = usePathname();
  
  const onLogout = async (event) => {
    event.preventDefault();
    if (logoutLoading) return;

    setLogoutLoading(true);
    const result = await logoutAction();
    if (result.error) {
      toast(getGqlErrorToast(result.error?.errors, e));
      setLogoutLoading(false);
      return;
    }
    deleteUser();
    setLogoutLoading(false);
  };
  
  return (
      <div className="ltn__drop-menu user-menu">
        <ul>
          <li>
            <span className="linkable">
              <i className="icon-user"></i>
            </span>
            <ul>
              {
                !!user ? (
                    <>
                      <li>
                        <Link href={PRIVATE_ROUTE_NAME}>{t('account.myAccount')}</Link>
                      </li>
                      <li>
                        <Link href="#ltn__utilize-wishlist-menu" className="ltn__utilize-toggle">{t('account.wishlist')}</Link>
                      </li>
                      <li>
                        <Link
                            onClick={(e) => onLogout(e)}
                            href={`${LOGOUT_ROUTE_NAME}?${CALLBACK_URL_PARAM}=${encodeURIComponent(pathname)}`}
                        >{t('account.logout')}</Link>
                      </li>
                    </>
                ) : (
                    <>
                      <li>
                        <Link href={`${LOGIN_ROUTE_NAME}?${CALLBACK_URL_PARAM}=${encodeURIComponent(pathname)}`}>
                          {t('account.signIn')}
                        </Link>
                      </li>
                      <li>
                        <Link href={`/register?${CALLBACK_URL_PARAM}=${encodeURIComponent(pathname)}`}>
                          {t('account.register')}
                        </Link>
                      </li>
                      <li>
                        <Link href="#ltn__utilize-wishlist-menu" className="ltn__utilize-toggle">{t('account.wishlist')}</Link>
                      </li>
                    </>
                )
              }
            </ul>
          </li>
        </ul>
      </div>
  );
};
